/**
 * Automation Module - Tasks Mutation Services
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../../services/useApi';
import { DELETE_TASK_AUTOMATION_URL, GET_ALL_AUTOMATIONS_URL } from '../constants';
import type { IDeleteTaskRequest, ITaskMutationResponse } from '../types';

export const useDeleteTask = () => {
  const { apiPrivate } = useApi();
  const queryClient = useQueryClient();

  return useMutation<ITaskMutationResponse, Error, IDeleteTaskRequest>({
    mutationFn: async ({ id }) => {
      const { data } = await apiPrivate.delete(`${DELETE_TASK_AUTOMATION_URL}?Id=${id}`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ALL_AUTOMATIONS_URL] });
    },
  });
};
